import crow from './image/crow.png'
import mortis from './image/mortis.png'
import karl from './image/karl.png'
import mrP from './image/mr-p.png'
import piper from './image/piper.png'
import shelly from './image/shelly.png'

const arrCards = [
    {
        name: 'crow',
        image: crow,  
        flipped: false,
        guessed: false,
        id: 0
    },
    {
        name: 'mortis',
        image: mortis,  
        flipped: false,
        guessed: false,
        id: 1
    },
    {
        name: 'karl',
        image: karl,  
        flipped: false,
        guessed: false,
        id: 2
    },
    {
        name: 'mrP',
        image: mrP,  
        flipped: false,
        guessed: false,
        id: 3
    },
    {
        name: 'piper',
        image: piper,  
        flipped: false,
        guessed: false,
        id: 4
    },    
    {
        name: 'shelly',
        image: shelly,  
        flipped: false,
        guessed: false,
        id: 5
    },
    {
        name: 'crow',
        image: crow,  
        flipped: false,
        guessed: false,
        id: 6
    },
    {
        name: 'mortis',
        image: mortis,  
        flipped: false,
        guessed: false,
        id: 7
    },
    {
        name: 'karl',
        image: karl,  
        flipped: false,
        guessed: false,
        id: 8
    },
    {
        name: 'mrP',
        image: mrP,  
        flipped: false,
        guessed: false,
        id: 9
    },
    {
        name: 'piper',
        image: piper,  
        flipped: false,
        guessed: false,
        id: 10
    },    
    {
        name: 'shelly',
        image: shelly,  
        flipped: false,
        guessed: false,
        id: 11
    }
]

export default arrCards